var _excluded = ["items", "isItemDisabled", "itemToString", "defaultHighlightedIndex", "target", "onInputValueChange", "layoutDependency"],
    _excluded2 = ["isOpen", "getItemProps"],
    _excluded3 = ["inputValue"],
    _excluded4 = ["show"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useState } from 'react';
import { useCombobox } from 'downshift';
import { useForwardedRef } from '@adsk/alloy-helpers';
import { useOverlay } from '@adsk/alloy-overlay';
import { defaultLabelGetter } from '../helpers/defaultGetters';
import useDisabledItems, { useGetItemProps } from './useDisabledItems';
/**
 * A hook used to manage all logic needed for an Autocomplete (searchable) dropdown.
 */

export default (function (_ref) {
  var itemsProp = _ref.items,
      _ref$isItemDisabled = _ref.isItemDisabled,
      isItemDisabled = _ref$isItemDisabled === void 0 ? function (item) {
    return !!item.disabled;
  } : _ref$isItemDisabled,
      _ref$itemToString = _ref.itemToString,
      itemToString = _ref$itemToString === void 0 ? function (item) {
    return defaultLabelGetter(item);
  } : _ref$itemToString,
      _ref$defaultHighlight = _ref.defaultHighlightedIndex,
      defaultHighlightedIndex = _ref$defaultHighlight === void 0 ? 0 : _ref$defaultHighlight,
      target = _ref.target,
      _onInputValueChange = _ref.onInputValueChange,
      layoutDependency = _ref.layoutDependency,
      props = _objectWithoutProperties(_ref, _excluded);

  var targetRef = useForwardedRef(target || null);

  var _useDisabledItems = useDisabledItems({
    items: itemsProp,
    isItemDisabled: isItemDisabled
  }),
      allItems = _useDisabledItems.items;

  var _useState = useState(allItems),
      _useState2 = _slicedToArray(_useState, 2),
      items = _useState2[0],
      setItems = _useState2[1];

  var getFilteredItems = function getFilteredItems(inputValue) {
    return allItems.filter(function (item) {
      return Object.keys(item).some(function (key) {
        var value = item[key];

        if (typeof value !== 'string') {
          return false;
        }

        return value.toLowerCase().includes(inputValue.toLowerCase());
      });
    });
  };

  var _useCombobox = useCombobox(_objectSpread({
    items: items,
    itemToString: itemToString,
    onInputValueChange: function onInputValueChange(_ref2) {
      var inputValue = _ref2.inputValue,
          args = _objectWithoutProperties(_ref2, _excluded3);

      var matchingItems = inputValue ? getFilteredItems(inputValue) : allItems;
      setItems(matchingItems);
      _onInputValueChange === null || _onInputValueChange === void 0 ? void 0 : _onInputValueChange(_objectSpread({
        inputValue: inputValue
      }, args));
    },
    defaultHighlightedIndex: defaultHighlightedIndex
  }, props)),
      downshiftIsMenuOpen = _useCombobox.isOpen,
      getItemProps = _useCombobox.getItemProps,
      useComboboxReturnValue = _objectWithoutProperties(_useCombobox, _excluded2);

  var _useOverlay = useOverlay(_objectSpread({
    placement: 'bottom-start',
    show: downshiftIsMenuOpen,
    target: targetRef,
    layoutDependency: "".concat(items.length).concat(layoutDependency)
  }, props)),
      useOverlayIsOpen = _useOverlay.show,
      useOverlayReturnValue = _objectWithoutProperties(_useOverlay, _excluded4);

  return _objectSpread(_objectSpread({
    isOpen: useOverlayIsOpen,
    menuItems: items,
    getItemProps: useGetItemProps({
      getItemProps: getItemProps
    })
  }, useComboboxReturnValue), useOverlayReturnValue);
});
//# sourceMappingURL=useAutocomplete.js.map